const am = {
  language: "ቋንቋ",
  loading: "በመጫን ላይ",
  welcome: {
    title: "ወደ truBuy እንኳን በደህና መጡ",
    description: "አገልግሎት የተሻለ የግዢ ስርዓት",
  },
  app: {
    title: "TruBuy",
    description: "የግዢ ስርዓት ለተሻለ ግዢ እንቅስቃሴ",
  },
  header: {
    logout: "ውጣ",
  },
  theme: {
    switch: "ገጽታ ለውጥ",
    dark: "ጨለማ",
    light: "ብርሃን",
  },
  languageSwitcher: {
    switch: "ቋንቋ ለውጥ",
    en: "እንግሊዝኛ",
    am: "አማርኛ",
  },
  dashboard: {
    title: "የግዢ ዳሽቦርድ",
    welcome: "እንኳን ደህና መጡ!",
    summary: "ከዕቅድ እስከ ክፍያ የግዢ ሂደትዎን ይከታተሉ",
    procurementFlow: "የግዢ ሂደት",
    navigateFlow: "በግዢ ቧንቧዎ ውስጥ ይሂዱ",
    quickActions: "ፈጣን ተግባራት",
    recentItems: "የቅርብ ጊዜ እቃዎች",
    viewAll: "ሁሉንም ይመልከቱ",
    noItems: "ምንም ዘመናዊ እቃዎች የሉም",
    createNew: "አዲስ ይፍጠሩ",
  },
  procurementPlans: {
    title: "የግዢ ዕቅድ መሣሪያዎች",
    create: "ዕቅድ ፍጠር",
    edit: "ዕቅድ አርትዕ",
    show: "ዕቅድ ይመልከቱ",
    list: "ሁሉም ዕቅዶች",
  },
  users: {
    title: "ተጠቃሚዎች",
    create: "ተጠቃሚ ፍጠር",
    edit: "ተጠቃሚ አርትዕ",
    show: "ተጠቃሚ ይመልከቱ",
    list: "ሁሉም ተጠቃሚዎች",
  },
  suppliers: {
    title: "አቅራቢዎች",
    create: "አቅራቢ ፍጠር",
    edit: "አቅራቢ አርትዕ",
    show: "አቅራቢ ይመልከቱ",
    list: "ሁሉም አቅራቢዎች",
  },
  products: {
    title: "ምርቶች",
    create: "ምርት ፍጠር",
    edit: "ምርት አርትዕ",
    show: "ምርት ይመልከቱ",
    list: "ሁሉም ምርቶች",
  },
  requisitions: {
    title: "ድጋፍ መጠየቂያዎች",
    create: "ድጋፍ መጠየቂያ ፍጠር",
    edit: "ድጋፍ መጠየቂያ አርትዕ",
    show: "ድጋፍ መጠየቂያ ይመልከቱ",
    list: "ሁሉም ድጋፍ መጠየቂያዎች",
  },
  purchaseOrders: {
    title: "የግዢ ትዕዛዞች",
    create: "ትዕዛዝ ፍጠር",
    edit: "ትዕዛዝ አርትዕ",
    show: "ትዕዛዝ ይመልከቱ",
    list: "ሁሉም ትዕዛዞች",
  },
  // Menu Group Translations
  resources: {
    procurement: {
      title: "ግዢ",
    },
    execution: {
      title: "ማስፈጸ᚜",
    },
    templates: {
      title: "ካልተቀመጡ",
    },
    finance: {
      title: "ፋይናንስ",
    },
    configuration: {
      title: "ማስተካከል",
    },
  },
  organization: {
    title: "ድርጅት",
    create: "ድርጅት ፍጠር",
    edit: "ድርጅት አርትዕ",
    show: "ድርጅት ይመልከቱ",
    list: "ሁሉም ድርጅቶች",
  },
};

export default am;
